import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Product,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.owner}owners/${COMMON_QUERY_PARAMS.OWNER_ID}/products/${COMMON_QUERY_PARAMS.OWNER_PRODUCT_ID}`;

interface GetOrderByOwnerIdPayload {
  ownerId: string;
  ownerProductId: string;
}

const getProductsByOwnerId = async ({
  ownerId,
  ownerProductId,
}: GetOrderByOwnerIdPayload): Promise<
  BackResponse<Product[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.OWNER_ID, ownerId).replace(
      COMMON_QUERY_PARAMS.OWNER_PRODUCT_ID,
      ownerProductId,
    );

    const response = await apiCall<BackResponse<Product[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getProductsByOwnerId;
